// Custom webC for handling animations
class AnimateOnView extends HTMLElement {
    constructor() {
        super();
        this.observer = null;
        this.triggerElement = null;
    }

    connectedCallback() {
        // Get data attributes
        const targetSelectors = this.dataset.targetClass.split(',').map(sel => sel.trim());
        const threshold = parseFloat(this.dataset.threshold) || 0.2;
        const translateY = parseInt(this.dataset.translateY) || 64;
        const easing = this.dataset.easing || 'cubicBezier(0, 0, 0.3, 1)';
        const delay = parseInt(this.dataset.delay) || 150;
        const duration = parseInt(this.dataset.duration) || 600;
        const triggerSelector = this.dataset.trigger;

        // Set initial opacity of target elements to 0
        targetSelectors.forEach(selector => {
            const elements = this.querySelectorAll(selector);
            elements.forEach(el => {
                el.style.opacity = '0.01';
            });
        });

        // Define the animation function
        const animateElements = () => {
            targetSelectors.forEach(selector => {
                const elements = this.querySelectorAll(selector);
                anime({
                    targets: elements,
                    translateY: [translateY, 0],
                    opacity: [0, 1],
                    easing: easing,
                    duration: duration,
                    delay: anime.stagger(delay),
                });
            });
        };

        if (triggerSelector) {
            // If data-trigger is provided, set up click event listener
            this.triggerElement = document.querySelector(triggerSelector);
            if (this.triggerElement) {
                this.triggerElement.addEventListener('click', animateElements);
            } else {
                console.warn(`Trigger element not found for selector: ${triggerSelector}`);
            }
        } else {
            // If no data-trigger, use Intersection Observer
            this.observer = new IntersectionObserver(
                (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            animateElements();
                            // Stop observing after animation
                            observer.unobserve(entry.target);
                        }
                    });
                },
                { threshold: threshold }
            );

            // Start observing this element
            this.observer.observe(this);
        }
    }

    disconnectedCallback() {
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.triggerElement) {
            this.triggerElement.removeEventListener('click', this.animateElements);
        }
    }
}

// Register the custom element
customElements.define('animate-on-view', AnimateOnView);
